import { useContext } from "react";

import { DataTableContext } from "ui/DataTable/DataTableProvider";

// This allows context to be more easily shimmed in Enzyme shallow testing.
/* istanbul ignore next core react function */
const useDataTable = () => useContext(DataTableContext);

export default useDataTable;
